import Vue from 'vue'
import { defineStore } from 'pinia'
import pinia from '@/store'
import { useTokenStore, ls } from '@/store/token'
import { HTTPClient } from '@rjgf/http-client'
import type { InitAppUserInfoOutput } from '@/api/swagger'
import { api } from '@/api'
import { useMenuStore } from '@/store/menu'
import { useClientStore, ClientType } from '@/store/client'
import { GlobalActions } from '../../../../enums/globa'

const tokenStore = useTokenStore(pinia)
const menuStore = useMenuStore(pinia)
const clientStore = useClientStore(pinia)

interface UserState {
  userInfo: InitAppUserInfoOutput & any
}

export const useUserStore = defineStore('useUserMainStore', {
  state(): UserState {
    return {
      userInfo: {
        userId: '',
        userName: '',
        realName: '',
        enterpriseId: '',
        phoneNumber: '',
        enterpriseName: '',
        sex: 1,
        status: 1,
        userType: 0,
        enterpriseType: '',
        isFace: false,
        faceState: 0,
        isStopCode: false,
      },
    }
  },
  actions: {
    async logged() {
      try {
        const token = tokenStore.getToken()
        if (this.userInfo.id) {
          HTTPClient.setToken(token, 'Bearer')
          return Promise.resolve(token)
        }
        return new Promise(async (resolve, reject) => {
          if (token) {
            HTTPClient.setToken(token, 'Bearer')
            const res = await this.init()
            if (res.data.userInfo) {
              this.setUserInfo(res.data.userInfo)
              ls.set('user', res.data.userInfo)
              menuStore.init({
                originalMenus: res.data.menus,
                ...res.data,
              })

              // 主应用是权限权威来源，加载完菜单/按钮后主动广播，
              // 避免子应用先于主应用挂载时快照到的按钮权限为空、导致 v-permission 元素不显示
              Vue.prototype.$setGlobalState({
                action: GlobalActions.InitMenu,
                menus: res.data.menus || [],
                buttons: res.data.buttons || [],
              })

              const clients = res.data.clients || []
              const currentClient =
                // 如过角色只含电动车平台，就显示电动车平台，否则均显示消防平台
                !clients.includes(ClientType.Web) && clients.includes(ClientType.ElectricVehicleInspection)
                  ? ClientType.ElectricVehicleInspection
                  : ClientType.Web
              clientStore.setClientInfo({
                clients,
                currentClient: ls.get('client') || currentClient,
              })
            }
            resolve(token)
          } else reject()
        })
      } catch (e) {
        console.log(e)
      }
    },
    logout() {
      tokenStore.clear()
      this.clearUserInfo()
    },
    setUserInfo(info: InitAppUserInfoOutput) {
      this.userInfo = info
    },
    clearUserInfo() {
      this.userInfo = {
        userId: '',
        userName: '',
        realName: '',
        enterpriseId: '',
        phoneNumber: '',
        enterpriseName: '',
        sex: 1,
        status: 1,
        userType: 0,
        enterpriseType: '',
        isFace: false,
        faceState: 0,
        isStopCode: false,
      }
    },
    init() {
      return api.get('/api/App/Init', {
        client: clientStore.currentClient || ClientType.Web,
      })
    },
  },
  getters: {
    info: (state: UserState) => {
      return state.userInfo
    },
  },
})
